import { useEffect } from 'preact/hooks';
import { useAuth } from '../lib/auth';
import { route } from 'preact-router';

export function SetupPage() {
  const { login } = useAuth();

  useEffect(() => {
    // Get session and workspace from URL params
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session');
    const workspaceId = params.get('workspace');

    if (sessionId && workspaceId) {
      // Store session and redirect to dashboard
      login(sessionId, workspaceId);
      route('/');
    }
  }, []);

  return (
    <div class="loading-screen">
      <div class="spinner" />
      <p>Setting up your workspace...</p>
    </div>
  );
}
